import { UnitSystem } from '@ravago/shared/page-data/models/config';
import { TranslateFn } from '@ravago/shared/translations/client';

export const unitSystems = (translate: TranslateFn): { id: UnitSystem; value: string }[] => [
   { id: 'SI', value: translate('product.information.physical-properties.metric') },
   { id: 'US', value: translate('product.information.physical-properties.imperial') }
];
